var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_239_6461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 60,
    height: 60,
    rx: 24,
    fill: "#FDA92F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 43.0148V46C62 47.1046 62.8954 48 64 48H66.9852C66.9313 47.559 66.7316 47.1459 66.4142 46.8284L63.1716 43.5858C62.8541 43.2684 62.441 43.0687 62 43.0148ZM47 48C47 44.134 50.134 41 54 41H61.7574C62.8182 41 63.8356 41.4214 64.5858 42.1716L67.8284 45.4142C68.5786 46.1644 69 47.1818 69 48.2426V60C69 63.866 65.866 67 62 67H54C50.134 67 47 63.866 47 60V48ZM52 55C51.4477 55 51 55.4477 51 56C51 56.5523 51.4477 57 52 57H63.5C64.0523 57 64.5 56.5523 64.5 56C64.5 55.4477 64.0523 55 63.5 55H52ZM51 52C51 51.4477 51.4477 51 52 51H58C58.5523 51 59 51.4477 59 52C59 52.5523 58.5523 53 58 53H52C51.4477 53 51 52.5523 51 52Z",
    fill: "#5557DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 24.5,
    width: 59,
    height: 59,
    rx: 23.5,
    stroke: "url(#paint0_linear_239_6461)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_239_6461",
    x: 0,
    y: 0,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_239_6461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_239_6461",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_6461",
    x1: 58,
    y1: 24,
    x2: 58,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8208cfc9220cce668e01cde4851b660b.svg";
export { ForwardRef as ReactComponent };